const KEY = 'yv-src';

export const captureSource = () => {
  if (sessionStorage.getItem(KEY)) return;
  const p = new URLSearchParams(window.location.search);
  const src = { landing_page: window.location.pathname, referrer: document.referrer ? new URL(document.referrer).hostname : '' };
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((k) => { if (p.get(k)) src[k] = p.get(k); });
  sessionStorage.setItem(KEY, JSON.stringify(src));
};

export const getSource = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch { return {}; }
};
